import { Phone, Mail, Globe, Calendar, Star, Download, UserPlus } from 'lucide-react';
import { Button } from './ui/button';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_insure-plus-1/artifacts/24wkpkvm_logo.png';
const PHOTO_URL = 'https://customer-assets.emergentagent.com/job_insure-plus-1/artifacts/ytwcldm5_BFB_0045.jpg';
const PHONE_DISPLAY = '(914) 266-0223';
const PHONE_TEL = '+19142660223';
const EMAIL = 'dschwartz@trubridge.biz';
const WEBSITE = 'https://trubridgehealth.com';
const MEDICARE_URL = 'https://trubridgehealth.com/medicare';
const GOOGLE_REVIEWS_URL = 'https://g.page/r/CTQWVx0BK_KHEBM/review';

const VCARD = `BEGIN:VCARD
VERSION:3.0
N:Schwartz;Adeen;;;
FN:Adeen Schwartz
ORG:TruBridge Health
TITLE:Founder & Senior Insurance Advisor
TEL;TYPE=WORK,VOICE:+19142660223
EMAIL;TYPE=WORK:dschwartz@trubridge.biz
URL:https://trubridgehealth.com
END:VCARD`;

const handleSaveContact = () => {
  const blob = new Blob([VCARD], { type: 'text/vcard;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'Adeen-Schwartz-TruBridge-Health.vcf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export default function BusinessCard() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-md mx-auto px-5 py-8">

        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img src={LOGO_URL} alt="TruBridge Health" className="h-14 w-auto" />
        </div>

        {/* Photo + Name */}
        <div className="text-center mb-6">
          <img
            src={PHOTO_URL}
            alt="Adeen Schwartz"
            className="w-28 h-28 rounded-full object-cover mx-auto mb-4 shadow-lg border-4 border-white"
            data-testid="card-photo"
          />
          <h1 className="text-2xl font-bold text-gray-900" data-testid="card-name">Adeen Schwartz</h1>
          <p className="text-blue-600 font-medium text-sm mt-1">Founder & Senior Insurance Advisor</p>
          <p className="text-blue-600 font-semibold text-sm">TruBridge Health</p>
          <p className="text-gray-500 text-sm mt-3 leading-relaxed px-2">
            Helping individuals and families navigate Medicare and health insurance with clarity and confidence.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3 mb-8" data-testid="card-actions">
          {/* Call Me */}
          <a href={`tel:${PHONE_TEL}`} className="block" data-testid="card-call-btn">
            <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-6 text-base font-semibold rounded-xl shadow-sm">
              <Phone className="mr-3 h-5 w-5" />
              Call Me — {PHONE_DISPLAY}
            </Button>
          </a>

          {/* Email Me */}
          <a href={`mailto:${EMAIL}`} className="block" data-testid="card-email-btn">
            <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-6 text-base font-semibold rounded-xl shadow-sm">
              <Mail className="mr-3 h-5 w-5" />
              Email Me
            </Button>
          </a>

          {/* Save My Contact */}
          <div>
            <Button
              onClick={handleSaveContact}
              className="w-full bg-slate-800 hover:bg-slate-900 text-white py-6 text-base font-semibold rounded-xl shadow-sm"
              data-testid="card-save-btn"
            >
              <UserPlus className="mr-3 h-5 w-5" />
              Save My Contact
            </Button>
            <p className="text-center text-xs text-gray-400 mt-1.5">
              Add me to your phone so you can reach me when Medicare questions come up.
            </p>
          </div>

          {/* Schedule Q&A */}
          <a href={MEDICARE_URL} className="block" data-testid="card-schedule-btn">
            <Button className="w-full bg-yellow-400 hover:bg-yellow-500 text-gray-900 py-6 text-base font-bold rounded-xl shadow-sm">
              <Calendar className="mr-3 h-5 w-5" />
              Schedule a Free 15-Minute Medicare Q&A
            </Button>
          </a>

          {/* Visit Website */}
          <a href={WEBSITE} className="block" data-testid="card-website-btn">
            <Button variant="outline" className="w-full border-2 border-blue-600 text-blue-600 hover:bg-blue-50 py-6 text-base font-semibold rounded-xl">
              <Globe className="mr-3 h-5 w-5" />
              Visit TruBridge Health
            </Button>
          </a>

          {/* Google Reviews */}
          <a href={GOOGLE_REVIEWS_URL} className="block" data-testid="card-reviews-btn">
            <Button variant="outline" className="w-full border-2 border-gray-300 text-gray-700 hover:bg-gray-50 py-6 text-base font-semibold rounded-xl">
              <Star className="mr-3 h-5 w-5 text-yellow-500" />
              Read Our Google Reviews
            </Button>
          </a>
        </div>

        {/* Footer Info */}
        <div className="border-t border-gray-200 pt-6 text-center" data-testid="card-footer">
          <div className="flex items-center justify-center space-x-2 mb-2">
            <img src={LOGO_URL} alt="TruBridge Health" className="h-7 w-auto" />
            <span className="font-bold text-gray-900 text-sm">TruBridge Health</span>
          </div>
          <p className="text-gray-500 text-xs mb-1">
            Serving Westchester County and the New York Tri-State area
          </p>
          <p className="text-gray-500 text-xs">{PHONE_DISPLAY}</p>
          <p className="text-gray-500 text-xs">{EMAIL}</p>
        </div>

      </div>
    </div>
  );
}
